import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const timeTrackerService = {
  getDashboard,
  getList,
  clockIn,
  clockOut,
  startBreak,
  endBreak,
};

function getDashboard(propertyId) {
  return axios
    .get(`${apiEndpoint.timeEntryDashboard}?property_id=${propertyId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return null;
    });
}

function getList(propertyId) {
  return axios
    .get(`${apiEndpoint.timeEntries}?property_id=${propertyId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return { entries: [] };
    });
}

function clockIn(data) {
  return axios
    .post(apiEndpoint.timeEntries, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function clockOut(id) {
  return axios
    .post(`${apiEndpointFunction.timeEntries(id)}/clock-out`, {}, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function startBreak(id) {
  return axios
    .post(`${apiEndpointFunction.timeEntries(id)}/start-break`, {}, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function endBreak(id) {
  return axios
    .post(`${apiEndpointFunction.timeEntries(id)}/end-break`, {}, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}
